export default __webpack_public_path__ + "static/media/delivery.5efcf8b5.png";